export default __webpack_public_path__ + "11a7ea85addeeb45ec4bdd2874a0de61.png";